import React from "react";

const Particle: React.FC<{ delay: number; duration: number; left: number }> = ({ delay, duration, left }) => (
    <div
        style={{
            position: 'absolute',
            width: '2px',
            height: '2px',
            background: Math.random() > 0.5 ? 'rgba(255, 140, 0, 0.6)' : 'rgba(255, 165, 50, 0.4)',
            borderRadius: '50%',
            left: `${left}%`,
            animation: `float ${duration}s infinite linear`,
            animationDelay: `${delay}s`,
        }}
    />
);

const Particles: React.FC = () => {
    const particles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        delay: Math.random() * 20,
        duration: 15 + Math.random() * 10,
        left: Math.random() * 100,
    }));

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
            pointerEvents: 'none',
        }}>
            <style>{`
                @keyframes float {
                    0% {
                        transform: translateY(100vh) translateX(0px);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    90% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(-100px) translateX(100px);
                        opacity: 0;
                    }
                }
            `}</style>
            {particles.map(particle => (
                <Particle
                    key={particle.id}
                    delay={particle.delay}
                    duration={particle.duration}
                    left={particle.left}
                />
            ))}
        </div>
    );
};

export default Particles